import { CircularProgress } from 'ui/components'

import { useGetEditSAR } from '../../../hooks/sar'
import { ManageSARPage } from './ManageSARPage'
import { useRouting } from './hooks'

const ManageSARPageWrapper = () => {
  const { id } = useRouting()
  const { data, isFetching } = useGetEditSAR(id)

  if (!data || isFetching) {
    return <CircularProgress centered />
  }

  return <ManageSARPage id={id} data={data} />
}

export default ManageSARPageWrapper
